import React, { useState, useEffect } from 'react';
import './MatchCountdown.css';

const TURKEY_OFFSET_MS = 3 * 60 * 60 * 1000; // UTC+3

// Pazartesi 22:00-23:00 Türkiye saati
const MATCH_DAY = 1;
const MATCH_START_HOUR = 22;
const MATCH_START_MIN = 0;
const MATCH_END_HOUR = 23;
const MATCH_END_MIN = 0;

function getTurkeyVirtual(): Date {
  return new Date(Date.now() + TURKEY_OFFSET_MS);
}

function getNextMatchStart(): Date {
  const t = getTurkeyVirtual();
  const day = t.getUTCDay();
  const hour = t.getUTCHours();
  const min = t.getUTCMinutes();
  const date = t.getUTCDate();
  const month = t.getUTCMonth();
  const year = t.getFullYear();

  const targetHour = MATCH_START_HOUR - 3;
  const nextMatch = new Date(Date.UTC(year, month, date, targetHour, MATCH_START_MIN, 0, 0));

  const isAfterMatch = day === MATCH_DAY && (hour > MATCH_END_HOUR || (hour === MATCH_END_HOUR && min >= MATCH_END_MIN));

  if (isAfterMatch) {
    nextMatch.setUTCDate(nextMatch.getUTCDate() + 7);
  } else if (day !== MATCH_DAY) {
    nextMatch.setUTCDate(nextMatch.getUTCDate() + (day === 0 ? 1 : 8 - day));
  }

  return nextMatch;
}

export const MatchCountdown: React.FC = () => {
  const [state, setState] = useState<'countdown' | 'live'>('countdown');
  const [display, setDisplay] = useState<{ d: number; h: number; m: number; s: number } | { minute: number }>({ d: 0, h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const t = getTurkeyVirtual();
      const day = t.getUTCDay();
      const hour = t.getUTCHours();
      const min = t.getUTCMinutes();

      const isMatchDay = day === MATCH_DAY;
      const isMatchTime = isMatchDay && (
        (hour === MATCH_START_HOUR && min >= MATCH_START_MIN) ||
        (hour === MATCH_END_HOUR && min < MATCH_END_MIN)
      );

      if (isMatchTime) {
        const matchMinute = hour === MATCH_START_HOUR
          ? min - MATCH_START_MIN + 1
          : 30 + min + 1;
        setState('live');
        setDisplay({ minute: Math.min(matchMinute, 60) });
      } else {
        setState('countdown');
        const next = getNextMatchStart();
        const diff = next.getTime() - Date.now();

        if (diff <= 0) {
          setDisplay({ d: 0, h: 0, m: 0, s: 0 });
        } else {
          const d = Math.floor(diff / (1000 * 60 * 60 * 24));
          const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const s = Math.floor((diff % (1000 * 60)) / 1000);
          setDisplay({ d, h, m, s });
        }
      }
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (state === 'live') {
    const minute = 'minute' in display ? display.minute : 0;
    return (
      <div className="match-countdown match-countdown--live">
        <span className="match-countdown__live-badge">CANLI</span>
        <span className="match-countdown__minute">{minute}'</span>
      </div>
    );
  }

  const { d, h, m, s } = 'd' in display ? display : { d: 0, h: 0, m: 0, s: 0 };
  return (
    <div className="match-countdown match-countdown--timer">
      <span className="match-countdown__unit">
        <span className="match-countdown__value">{String(d).padStart(2, '0')}</span>
        <span className="match-countdown__label">Gün</span>
      </span>
      <span className="match-countdown__unit">
        <span className="match-countdown__value">{String(h).padStart(2, '0')}</span>
        <span className="match-countdown__label">Saat</span>
      </span>
      <span className="match-countdown__unit">
        <span className="match-countdown__value">{String(m).padStart(2, '0')}</span>
        <span className="match-countdown__label">Dk</span>
      </span>
      <span className="match-countdown__unit">
        <span className="match-countdown__value">{String(s).padStart(2, '0')}</span>
        <span className="match-countdown__label">Sn</span>
      </span>
    </div>
  );
};
